"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @deprecated Use route type instead if it's possible
 */
const objectIdTypes = {
    c: { page: 'geo', name: 'Country' },
    d: { page: 'geo', name: 'Destination' },
    f: { page: 'geo', name: 'Resort' },
    g: { page: 'geo', name: 'CountryGroup' },
    h: { page: 'pdp', name: 'Hotel' },
    k: { page: 'geo', name: 'Continent' },
    o: { page: 'pdp', name: 'Roundtrip' },
    r: { page: 'geo', name: 'Region' },
    s: { page: 'pdp', name: 'Cruise' },
    t: { page: 'theme', name: 'Theme' },
};
exports.default = objectIdTypes;
//# sourceMappingURL=objectIdTypes.js.map